import {
  createFeatureSelector,
  createSelector,
  MemoizedSelector,
} from '@ngrx/store';
import { instanceFeatureKey, selectAllInstancesAdapter, State } from '../reducers/instance.reducer';

export const selectInstanceState: MemoizedSelector<object, State> =
  createFeatureSelector<State>(instanceFeatureKey);

export const selectAllInstances  = createSelector(
  selectInstanceState,
  selectAllInstancesAdapter
);
